export const generateWordHTML = (htmlContent) => {
    return `
        <html xmlns:o="urn:schemas-microsoft-com:office:office" 
              xmlns:w="urn:schemas-microsoft-com:office:word" 
              xmlns="http://www.w3.org/TR/REC-html40">
        <head>
            <meta charset="utf-8">
            <title>Ly Lich Khoa Hoc</title>
            <style>
                @page WordSection1 {
                    size: 595.3pt 841.9pt;
                    margin: 1.0in 0.6in 1.0in 0.6in;
                    mso-header-margin: 35.4pt;
                    mso-footer-margin: 35.4pt;
                    mso-paper-source: 0;
                }
                div.WordSection1 { page: WordSection1; }
                
                body { font-family: "Times New Roman", Times, serif; font-size: 14pt; line-height: 1.5; color: #000; }
                .cv-header { text-align: center; margin-bottom: 30px; }
                .cv-header h2, .cv-header h3 { margin: 5px 0; font-weight: bold; text-transform: uppercase; font-size: 15pt;}
                .cv-header p.italic { font-style: italic; font-size: 12pt; margin-top: 5px; }
                .cv-section { margin-bottom: 25px; }
                .cv-section p { margin: 10px 0; }
                .bold { font-weight: bold; }
                .italic { font-style: italic; }
                
                table { border-collapse: collapse; width: 100%; table-layout: fixed; }
                .cv-data-table { margin: 15px 0; width: 100%; table-layout: fixed; }
                .cv-data-table th, .cv-data-table td { 
                    border: 1px solid #000; 
                    padding: 4px; 
                    vertical-align: middle; 
                    word-wrap: break-word; 
                    overflow-wrap: break-word;
                }
                .cv-data-table th { font-weight: bold; text-align: center; background-color: #f2f2f2; }
                .layout-table td, .research-field-table td, .no-border-table td { border: none !important; padding: 4px 0; }
                .group-title { font-weight: bold; background-color: #f9f9f9; text-align: left; }
            </style>
        </head>
        <body>
            <div class="WordSection1">
                ${htmlContent}
            </div>
        </body>
        </html>
    `;
};